import { render, staticRenderFns } from "./headerBg.vue?vue&type=template&id=34d115ce&scoped=true&"
import script from "./headerBg.vue?vue&type=script&lang=js&"
export * from "./headerBg.vue?vue&type=script&lang=js&"
import style0 from "./headerBg.vue?vue&type=style&index=0&id=34d115ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d115ce",
  null
  
)

export default component.exports